import {
  getMessageHead, getMessageBody, postMessage, getChannelSubscribers, postChannelSubscribers, getMessageHeadEmail, getMessageBodyEmail
} from '@/api/chat.api'

export const WEBSOCKET_JOIN_ROOM = 'WEBSOCKET_JOIN_ROOM'
export const WEBSOCKET_FETCH_CHANNELS = 'WEBSOCKET_FETCH_CHANNELS'
export const WEBSOCKET_FETCH_CHANNELS_LOADING = 'WEBSOCKET_FETCH_CHANNELS_LOADING'
export const WEBSOCKET_FETCH_CHANNELS_DONE = 'WEBSOCKET_FETCH_CHANNELS_DONE'

export const WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS = 'WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS'
export const WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_LOADING = 'WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_LOADING'
export const WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_DONE = 'WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_DONE'
export const WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_ERROR = 'WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_ERROR'

export const WEBSOCKET_POST_CHANNELS_SUBSCRIBERS = 'WEBSOCKET_POST_CHANNELS_SUBSCRIBERS'
export const WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_LOADING = 'WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_LOADING'
export const WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_DONE = 'WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_DONE'
export const WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_ERROR = 'WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_ERROR'

export const WEBSOCKET_FETCH_MESSAGES = 'WEBSOCKET_FETCH_MESSAGES'
export const WEBSOCKET_FETCH_MESSAGES_LOADING = 'WEBSOCKET_FETCH_MESSAGES_LOADING'
export const WEBSOCKET_FETCH_MESSAGES_DONE = 'WEBSOCKET_FETCH_MESSAGES_DONE'
export const WEBSOCKET_FETCH_MESSAGES_ERROR = 'WEBSOCKET_FETCH_MESSAGES_ERROR'

export const WEBSOCKET_SEND_MESSAGE = 'WEBSOCKET_SEND_MESSAGE'
export const WEBSOCKET_SEND_MESSAGE_LOADING = 'WEBSOCKET_SEND_MESSAGE_LOADING'
export const WEBSOCKET_SEND_MESSAGE_DONE = 'WEBSOCKET_SEND_MESSAGE_DONE'
export const WEBSOCKET_SEND_MESSAGE_ERROR = 'WEBSOCKET_SEND_MESSAGE_ERROR'

export const WEBSOCKET_FETCH_MESSAGES_EMAIL = 'WEBSOCKET_FETCH_MESSAGES_EMAIL'
export const WEBSOCKET_FETCH_MESSAGES_EMAIL_LOADING = 'WEBSOCKET_FETCH_MESSAGES_EMAIL_LOADING'
export const WEBSOCKET_FETCH_MESSAGES_EMAIL_DONE = 'WEBSOCKET_FETCH_MESSAGES_EMAIL_DONE'
export const WEBSOCKET_FETCH_MESSAGES_EMAIL_ERROR = 'WEBSOCKET_FETCH_MESSAGES_EMAIL_ERROR'

export default {
  [WEBSOCKET_FETCH_CHANNELS] (context, { token, shipmentId, orderNumber }) {
    context.commit(WEBSOCKET_FETCH_CHANNELS_LOADING)
    const payloads = {
      type: WEBSOCKET_JOIN_ROOM,
      meta: { remote: true },
      payload: {
        shipmentId,
        orderNumber,
        token, // user will join room based on the company ID in the token,
        client: 'CUSTOMER'
      }
    }
    this._vm.$socket.emit('action', payloads)
    context.commit(WEBSOCKET_FETCH_CHANNELS_DONE)
  },

  [WEBSOCKET_FETCH_MESSAGES] (context, { shipmentId, orderNumber, typeMessage }) {
    context.commit(WEBSOCKET_FETCH_MESSAGES_LOADING)
    getMessageHead({ shipmentId, orderNumber, typeMessage })
      .then((resp) => {
        const pros = []
        for (let i = 0; i < resp.data.length; i++) {
          const shipmentDate = resp.data[i].messageDateBucket
          const res = getMessageBody({
            shipmentId, orderNumber, shipmentDate, typeMessage
          })
          pros.push(res)
        }
        Promise.all(pros).then((res) => {
          let data = []
          res.forEach((item) => {
            data = data.concat(item.data)
          })
          context.commit(WEBSOCKET_FETCH_MESSAGES_DONE, data)
        })
      })
      .catch((error) => {
        // eslint-disable-next-line
        context.commit(WEBSOCKET_FETCH_MESSAGES_ERROR, error)
      })
  },

  [WEBSOCKET_FETCH_MESSAGES_EMAIL](context, {
    shipmentId, orderNumber, typeMessage
  }) {
    context.commit(WEBSOCKET_FETCH_MESSAGES_EMAIL_LOADING)
    getMessageHeadEmail({ shipmentId, orderNumber, typeMessage, })
      .then((resp) => {
        const pros = []
        for (let i = 0; i < resp.data.length; i += 1) {
          const shipmentDate = resp.data[i].messageDateBucket
          const res = getMessageBodyEmail({
            shipmentId, orderNumber, shipmentDate, typeMessage,
          })
          pros.push(res)
        }
        Promise.all(pros).then((res) => {
          let data = []
          res.forEach((item) => {
            data = data.concat(item.data)
          })
            context.commit(WEBSOCKET_FETCH_MESSAGES_EMAIL_DONE, data)
        })
      })
      .catch((error) => {
        context.commit(WEBSOCKET_FETCH_MESSAGES_EMAIL_ERROR, error)
      })
  },

  [WEBSOCKET_SEND_MESSAGE] (context, { payload, typeMessage }) {
    context.commit(WEBSOCKET_SEND_MESSAGE_LOADING)
    return postMessage(payload, typeMessage)
      .then((response) => {
        context.commit(WEBSOCKET_SEND_MESSAGE_DONE, response)
      })
      .catch((error) => {
        context.commit(WEBSOCKET_SEND_MESSAGE_ERROR, error)
      })
  },

  [WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS] (context, { shipmentId, orderNumber, typeMessage }) {
    context.commit(WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_LOADING)
    getChannelSubscribers({ shipmentId, orderNumber, typeMessage })
      .then((response) => {
        context.commit(WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_DONE, response.data)
      })
      .catch((error) => {
        // eslint-disable-next-line
        context.commit(WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_ERROR, error)
      })
  },

  [WEBSOCKET_POST_CHANNELS_SUBSCRIBERS] (context, { payload, typeMessage }) {
    context.commit(WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_LOADING)
    return postChannelSubscribers(payload, typeMessage)
      .then((response) => {
        context.commit(WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_DONE, response.data)
      })
      .catch((error) => {
        context.commit(WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_ERROR, error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/actions.js